<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="localVisible"
    width="650px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item
        label="内容名称"
        prop="contentName"
      >
        <el-input
          v-model="formData.contentName"
          placeholder="不填则自动生成（格式：设施类型-周期-类型+序号）"
          maxlength="100"
        />
      </el-form-item>
      <el-form-item
        label="检查对象"
        prop="checkObjectName"
      >
        <el-input
          v-model="formData.checkObjectName"
          placeholder="选填，复合设施可填写灭火器、防毒面具等对象名称"
          maxlength="100"
          show-word-limit
          clearable
        />
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="消防系统"
            prop="systemId"
          >
            <el-select
              v-model="formData.systemId"
              placeholder="请选择"
              style="width: 100%"
              :disabled="type !== 'add'"
              @change="handleSystemChange"
            >
              <el-option
                v-for="item in systemList"
                :key="item.uuid"
                :label="item.systemName"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="设施类型"
            prop="deviceTypeId"
          >
            <el-select
              v-model="formData.deviceTypeId"
              placeholder="请选择"
              style="width: 100%"
              :disabled="type !== 'add'"
            >
              <el-option
                v-for="item in currentDeviceTypes"
                :key="item.uuid"
                :label="item.typeName"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="内容类型"
            prop="contentType"
          >
            <el-select
              v-model="formData.contentType"
              placeholder="请选择"
              style="width: 100%"
              :disabled="type !== 'add'"
            >
              <el-option
                v-for="opt in taskTypeOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="适用周期"
            prop="applyCycle"
          >
            <el-select
              v-model="formData.applyCycle"
              placeholder="请选择"
              style="width: 100%"
              :disabled="type !== 'add'"
            >
              <el-option
                v-for="opt in cycleTypeOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        label="检查内容"
        prop="content"
      >
        <el-input
          v-model="formData.content"
          type="textarea"
          :rows="5"
          placeholder="请输入检查内容"
          maxlength="1000"
        />
      </el-form-item>
      <el-form-item
        label="备注说明"
        prop="remark"
      >
        <el-input
          v-model="formData.remark"
          placeholder="选填"
          maxlength="500"
        />
      </el-form-item>
      <el-form-item
        label="额外内容"
        prop="allowExtraInput"
      >
        <el-switch
          v-model="formData.allowExtraInput"
          :active-value="1"
          :inactive-value="0"
        />
        <span style="margin-left: 10px">{{ formData.allowExtraInput === 1 ? '允许填写' : '不允许填写' }}</span>
        <span class="extra-input-tip">用于需要填写数值的检查项，如压力、数量等，便于输入具体数值。</span>
      </el-form-item>
      <el-form-item
        label="状态"
        prop="status"
      >
        <el-switch
          v-model="formData.status"
          :active-value="1"
          :inactive-value="0"
        />
        <span style="margin-left: 10px">{{ formData.status === 1 ? '启用' : '禁用' }}</span>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">
        取消
      </el-button>
      <el-button
        type="primary"
        :loading="submitting"
        @click="handleSubmit"
      >
        保存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
// 服务
import { checkContentService } from './checkContent.service';
// 工具函数
import {
  TASK_TYPE_OPTIONS,
  CYCLE_TYPE_OPTIONS,
  DEFAULT_TASK_TYPE,
  DEFAULT_CYCLE_TYPE
} from '@/features/gnmk/constants/taskCycleEnums';

export default {
  name: 'CheckContentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'add'
    },
    data: {
      type: Object,
      default: () => ({})
    },
    systemList: {
      type: Array,
      default: () => []
    },
    deviceTypeList: {
      type: Array,
      default: () => []
    },
    defaultSystemId: {
      type: String,
      default: ''
    },
    defaultDeviceTypeId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      taskTypeOptions: TASK_TYPE_OPTIONS,
      cycleTypeOptions: CYCLE_TYPE_OPTIONS,
      localVisible: false,
      submitting: false,
      formData: {
        uuid: '',
        contentName: '',
        checkObjectName: '',
        systemId: '',
        deviceTypeId: '',
        contentType: DEFAULT_TASK_TYPE,
        applyCycle: DEFAULT_CYCLE_TYPE,
        content: '',
        remark: '',
        status: 1,
        allowExtraInput: 0
      },
      formRules: {
        systemId: [{ required: true, message: '必选', trigger: 'change' }],
        deviceTypeId: [{ required: true, message: '必选', trigger: 'change' }],
        contentType: [{ required: true, message: '必选', trigger: 'change' }],
        applyCycle: [{ required: true, message: '必选', trigger: 'change' }],
        content: [{ required: true, message: '必填', trigger: 'blur' }]
      },
      currentDeviceTypes: []
    };
  },
  computed: {
    dialogTitle () {
      return this.type === 'add' ? '新增检查内容' : '编辑检查内容';
    }
  },
  methods: {
    initForm () {
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields();
        }

        if (this.type === 'add') {
          this.resetFormData();

          // 1. 优先使用传入的data（从卡片+号点击添加）
          if (this.data && this.data.systemId) {
            Object.assign(this.formData, {
              systemId: this.data.systemId,
              deviceTypeId: this.data.deviceTypeId,
              contentType: this.data.contentType,
              applyCycle: this.data.applyCycle
            });
            this.filterDeviceTypes();
          } else if (this.defaultSystemId) {
            // 2. 其次使用默认筛选条件（从搜索栏传入）
            this.formData.systemId = this.defaultSystemId;
            this.filterDeviceTypes();
            if (this.defaultDeviceTypeId) {
              this.formData.deviceTypeId = this.defaultDeviceTypeId;
            }
          }
        } else {
          this.formData = {
            ...this.data,
            checkObjectName: this.data.checkObjectName || '',
            allowExtraInput: this.data.allowExtraInput === 1 ? 1 : 0
          };
          this.filterDeviceTypes();
        }
      });
    },

    resetFormData () {
      this.formData = {
        uuid: '',
        contentName: '',
        checkObjectName: '',
        systemId: '',
        deviceTypeId: '',
        contentType: DEFAULT_TASK_TYPE,
        applyCycle: DEFAULT_CYCLE_TYPE,
        content: '',
        remark: '',
        status: 1,
        allowExtraInput: 0
      };
      this.currentDeviceTypes = [];
    },

    handleSystemChange () {
      this.formData.deviceTypeId = '';
      this.filterDeviceTypes();
    },

    filterDeviceTypes () {
      if (this.formData.systemId) {
        this.currentDeviceTypes = this.deviceTypeList.filter(t => t.systemId === this.formData.systemId);
      } else {
        this.currentDeviceTypes = [];
      }
    },

    handleClose () {
      this.$emit('update:visible', false);
      this.$emit('close');
    },

    handleSubmit () {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.submitting = true;
        const submitData = { ...this.formData };
        submitData.checkObjectName = (submitData.checkObjectName || '').trim();
        const request = this.type === 'add'
          ? checkContentService.addCheckContent(submitData)
          : checkContentService.updateCheckContent(submitData);

        request.then(() => {
          this.$message.success('保存成功');
          this.$emit('success');
          this.handleClose();
        }).finally(() => {
          this.submitting = false;
        });
      });
    }
  },
  watch: {
    visible (val) {
      this.localVisible = val;
      if (val) {
        this.initForm();
      }
    }
  }
};
</script>

<style lang="scss">
/* 不使用 scoped，让样式全局生效 */
.el-dialog__wrapper .el-form-item {
  margin-bottom: 18px !important;
}

.el-dialog__wrapper .el-form-item__error {
  position: relative !important;
  top: 0 !important;
  padding-top: 2px !important;
}

.el-dialog__wrapper .extra-input-tip {
  margin-left: 12px;
  color: #409eff;
  font-size: 12px;
}
</style>
